<template>
  <div>
    <div class="text-center">
      <h1>メールアドレスが変更されました。</h1>
    </div>
      <div class="announce-container">
        <span>メールアドレスの変更が完了しました。</span>
        <br>
        <br>
        <span>以下より再度ログインしてください</span>
        <br>
        <span><router-link :to="{name: 'Home'}">{{domain}}</router-link></span>
        <br>
        <br>
        <span>メールアドレス</span>
        <br>
        <br>
        <span>{{email}}</span>
      </div>
  </div>
</template>
<script>

export default {
  props: ['email'],

  data () {
    return {
      domain: process.env.NODE_DOMAIN + '/login'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/ChangeEmailSuccessfully.vue